var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-tip",class:[_vm.direction, _vm.recommend ? 'recommend' : '']},[_vm._t("default",[(_vm.msg)?_c('span',[_vm._v(_vm._s(_vm.msg))]):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }